export interface SignedOrderFacts {
  status: string | null;
  instruction: { status: string } | null;
}

export function isSignedOrder(order: SignedOrderFacts): boolean {
  return order.status === "APPROVED" && order.instruction?.status === "COMPLETED";
}
